import { ChangeDetectionStrategy, Component } from '@angular/core';
import { PlycaUiFilterGenericComponent } from '../../filter-generic.component';
import { FormConfig } from '@/app/components/forms/form.objects';
import { FilterDemoDTO } from '../_config/filter-generic-demo.model';
import { FilterGenericData } from '../../_config/filter-generic.model';

@Component({
  selector: 'plyca-ui-filter-generic-demo-one',
  templateUrl: './filter-generic-demo-one.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PlycaUiFilterGenericComponent]
})
export class PlycaUiFilterGenericDemoOneComponent {
  public formConfigFilters: FormConfig;
  public model: FilterDemoDTO = new FilterDemoDTO();
  public dataModelOnChange: FilterGenericData;

  public valuesOnChange(event: FilterGenericData): void {
    this.dataModelOnChange = event;
    this._observeFormChanges();
  }

  private _observeFormChanges(): void {
    const formGroup = this.dataModelOnChange.formGroup;
    if (formGroup && formGroup.value) {
      console.error(formGroup.value);
    }
  }
}
